import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BizService } from 'src/app/services/biz.service';
import { LanguageService } from 'src/app/services/language.service';
import { MenuService } from 'src/app/services/menu-service';
import { SecurityService } from 'src/app/services/security.service';
import { SwalWithDefaults } from 'src/shared/swal-dialog-default-options';

@Component({
  selector: 'app-delete-account',
  standalone: false,
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.css'
})
export class DeleteAccountComponent implements OnInit, OnDestroy {

  isSavingData = false;
  loadingSub: Subscription | undefined;
  savingSub: Subscription | undefined;

  constructor(
    private menuService: MenuService,
    private securityService: SecurityService
  ) { }

  ngOnInit(): void {
    this.loadingSub = this.menuService.loadingStatusChanged.subscribe((status: boolean) => {
      if (this.menuService.GetActiveMenuName() == 'Elimina Account') {
        if (status) {
          // this.data.refreshDevices().subscribe();
          // this.data.startPolling();
        }
      }
      else {
        //this.data.stopPolling();
      }
    });
    this.savingSub = this.menuService.savingStatusChanged.subscribe((status: boolean) => {
      this.isSavingData =  status;
    });
  }

  ngOnDestroy() {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
    if (this.savingSub) {
      this.savingSub.unsubscribe();
    }
  }

  operationInProgress = false;

  onCancel() {
    this.menuService.SetActiveMenuName('Home');
  }

  async onDisableAccount() {

    this.operationInProgress = true;

    await this.securityService.DisableAccount();

    this.operationInProgress = false;
  }
}